// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterLookupConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  FILTER_MODE: {
    DbStructure: 'DbStructure',
    UserDefined: 'UserDefined'
  },

  FILTER_LOOKUP_STATUSES: {
    VALID: 0,
    INVALID_QUERY_SOURCE: 1,
    INVALID_CONNECTION: 2,
    LOOKUP_IS_TENANT_FIELD: 4,
    LOOKUP_INVISIBLE: 8,
    DISPLAY_IS_TENANT_FIELD: 16,
    DISPLAY_INVISIBLE: 32
  },

  CONSTRAINTS: {
    presence: {
      presence: true,
      get message() {
        return localizer.getText('COMMON_CONSTRAINT_REQUIRED');
      }
    }
  },

  FILTER_LOOKUP_TYPES: {
    NONE: 0,
    LOOKUP_KEY: 1,
    USER_DEFINED: 2
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.FilterLookupConstants.js